import { Injectable } from '@angular/core';
import { Response, ResponseContentType, RequestOptions, URLSearchParams } from '@angular/http';

import { AuthHttp } from 'app/infrastructure/common/index';
import { AppSettings } from 'app/infrastructure/settings/index';

@Injectable()
export class ReportService {
    constructor(private http: AuthHttp) { }

    requestReport(searchParams: any,apiEndpoint:string): any {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in searchParams) {
            let value = undefined;

            if (searchParams[key] && searchParams[key] instanceof Date) {
                value = searchParams[key].toUTCString();
            } else {
                value = searchParams[key];
            }

            params.set(key, value);
        }

        let options: RequestOptions = new RequestOptions({ search: params, responseType: ResponseContentType.Blob });
        return this.http.get(AppSettings.apiEndpoint + apiEndpoint, options)
            .map(
            (response: Response) => {
                let contentType = response.headers.get('Content-Type');
                return new Blob([response.blob()], { type: contentType });
            }
            );
    }
}


// WEBPACK FOOTER //
// ./src/app/infrastructure/common/report.service.ts